import { makeStyles } from "@material-ui/core"

export default makeStyles((theme) => ({
  footer: {
    padding: theme.spacing(1),
  },
}))
